export default [{
	titulo: 'Lei Aldir Blanc',
	icone: 'menu-icon fa fa-caret-right',
	url: '/links/lei-aldir-blanc',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]